import { signOut as amplifySignOut } from "aws-amplify/auth";
import { revokeAllSessions } from "@/lib/authBackend/revokeAllSessions";
import type { SignOutArgs } from "@/lib/authBackend/types";

export async function signOut(args?: SignOutArgs): Promise<void> {
  if (args?.global) await revokeAllSessions();
  await amplifySignOut({ global: args?.global ?? false });
}
